import { render } from "./SvgProhibitedBadge.vue?vue&type=template&id=4147be2a&ts=true"
import script from "./SvgProhibitedBadge.vue?vue&type=script&lang=ts"
export * from "./SvgProhibitedBadge.vue?vue&type=script&lang=ts"

import "./SvgProhibitedBadge.vue?vue&type=style&index=0&id=4147be2a&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__